import {
  post_request
} from '../axiosFun';

// 故障处理
export const get_fault_record_list = (params) => {
  params = {
    row: {
      vin: params.vin,
      car_type: params.carType,
      fault_details: params.faultDetails,
      status: params.faultStatus,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/fault_record_list", params)
}
// 编辑
export const get_fault_record_handle = (params) => {
  params = {
    row: {
      id: params.id,
      status: 1,
      note: params.outcome
    }
  }
  return post_request("/web/fault_record_handle", params)
}




// WEBPACK FOOTER //
// ./src/api/faultOrder_mn/faultOrder.js